import { Controller } from "@hotwired/stimulus"
import { chime } from "../lair/chime.js"
import { repaintSatchel } from "../lair/satchel.js"

// The forge (commons/_smithy). Make used to be a plain form: a POST, a
// redirect, and the whole venue — scene, sprites, every panel — drawn again
// for one bar in the satchel, with nothing on the screen to say the press
// had landed until it all came back (Saoud: "the page just lagged? it was a
// bad waiting state and then page reloaded"). Now the press is answered in
// place: the button says it is working, the smith's word lands under the
// heading, the satchel and every recipe row come level with the new bag,
// and a thing made once is shown made. The form still posts on its own
// without this controller; the server answers HTML to a plain form and
// JSON to this one.
export default class extends Controller {
  static targets = [ "note" ]

  connect() {
    this.busy = false
  }

  async make(event) {
    event.preventDefault()
    if (this.busy) return

    const form = event.currentTarget
    const row = form.closest("[data-recipe]")
    const button = form.querySelector("button")
    const was = button?.textContent
    this.busy = true
    this.working(row, button, true)
    this.say(null)

    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: this.headers(),
        body: new FormData(form)
      })
      const payload = await response.json().catch(() => ({}))
      if (!response.ok) throw new Error(payload.error || "The smith shook his head.")
      this.settle(row, payload)
    } catch (error) {
      this.say(error.message, { alert: true })
      chime("care")
    } finally {
      this.busy = false
      this.working(row, button, false, was)
    }
  }

  // The moment after: satchel and rows level with the bag, the smith's word
  // said, the row warmed for a beat. A thing made — the keeper's or the
  // dragon's — is shown made and its form is gone; a bar's row stays, since
  // there is no end to bars.
  settle(row, payload) {
    if (payload.satchel) repaintSatchel(payload.satchel)
    this.say(payload.line)
    chime(payload.made?.kind === "material" ? "sit" : "coin")

    if (row) {
      row.classList.remove("ll-work__job--made")
      void row.getBoundingClientRect()
      row.classList.add("ll-work__job--made")
      if (payload.made && payload.made.kind !== "material") {
        row.dataset.recipeBlocked = "true"
        row.querySelector("[data-recipe-reason]")?.remove()
        const span = document.createElement("span")
        span.className = "ll-meta"
        span.dataset.recipeMade = ""
        span.textContent = "Made."
        row.querySelector("form")?.replaceWith(span)
      }
    }

    this.element.dispatchEvent(new CustomEvent("forge:made", { bubbles: true, detail: payload }))
  }

  working(row, button, on, was) {
    row?.classList.toggle("ll-work__job--working", on)
    if (!button) return
    button.disabled = on
    button.setAttribute("aria-busy", on ? "true" : "false")
    if (on) button.textContent = "Making…"
    else if (was) button.textContent = was
  }

  say(message, { alert = false } = {}) {
    if (!this.hasNoteTarget) return
    this.noteTarget.textContent = message || ""
    this.noteTarget.hidden = !message
    this.noteTarget.classList.toggle("ll-forge__note--alert", alert)
  }

  headers() {
    return {
      "Accept": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
    }
  }
}
